'use es6';

import Engagement from 'customer-data-objects/engagement/EngagementRecord';
import PropTypes from 'prop-types';
const EngagementType = PropTypes.instanceOf(Engagement);
export default EngagementType;